<template>
  <v-row>

    <template v-if="data.type_postulations_id==1 || data.type_postulations_id==2">
      <v-col cols="12">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Convocatoria enviada por:
              </p>
              

              <p class="font-weight-light pt-4" v-if="data.user">
                {{ data.user.name + ' ' + data.user.lastname  }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Correo electrónico
              </p>
              
              <p class="font-weight-light pt-4"  v-if="data.user">
                {{ data.user.email }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Tipo de postulación
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.type_postulations.name }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Vertical de trabajo:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.vertical_works.name }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Grado de desarrollo actual:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.development_degree_ip.name }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Estadio de la Idea:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.entrepreneurship_stadia.name }}
              </p>
            </v-col>

          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                País:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.country.name  }}
              </p>
            </v-col>
            
            <template v-if="data.country.name.toLowerCase()=='argentina'">
              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Provincia:
                </p>
                
                <p class="font-weight-light pt-4">
                  {{ data.provincia.name  }}
                </p>
              </v-col>

              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Localidad:
                </p>
                
                <p class="font-weight-light pt-4">
                  {{ data.localidad.name }}
                </p>
              </v-col>
            </template>

            <template v-if="data.country.name.toLowerCase()!='argentina'">
              <v-col cols="12" xl="4" md="4" sm="12" v-if="data.other_provincia">
                <p class="font-weight-regular text-uppercase">
                  Provincia:
                </p>
                
                <p class="font-weight-light pt-4">
                  {{ data.other_provincia  }}
                </p>
              </v-col>

              <v-col cols="12" xl="4" md="4" sm="12" v-if="data.other_localidad">
                <p class="font-weight-regular text-uppercase">
                  Localidad:
                </p>
                
                <p class="font-weight-light pt-4">
                  {{ data.other_localidad }}
                </p>
              </v-col>
            </template>
  
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Título:
              </label>
            </v-col>
            <v-col cols="12">
              <label class="font-weight-light">
                {{ data.title }}
              </label>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Resumen:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.description }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Equipo:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.team }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Beneficiarios/clientes/usuarios:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.beneficiary_clients_users }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Problema:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.problem }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Solución:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.solution }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Innovación/Valor Agregado:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.innovation }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </template>

    <template v-if="data.type_postulations_id==3">
      <v-col cols="12">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Convocatoria enviada por:
              </p>
              
              <p class="font-weight-light pt-4" v-if="data.user">
                {{ data.user.name + ' ' + data.user.lastname  }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Correo electrónico
              </p>
              
              <p class="font-weight-light pt-4" v-if="data.user">
                {{ data.user.email }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Tipo de postulación
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.type_postulations.name }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Vertical de trabajo:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.vertical_works.name }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Grado de desarrollo actual:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.development_degree_mdn.name }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Estadio de la Idea:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.entrepreneurship_stadia.name }}
              </p>
            </v-col>

          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Pais:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.country.name  }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Provincia:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.provincia.name }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Localidad:
              </p>
              
              <p class="font-weight-light pt-4">
                {{ data.localidad.name }}
              </p>
            </v-col>

          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Titulo de la idea:
              </label>
            </v-col>
            <v-col cols="12">
              <label class="font-weight-light">
                {{ data.title }}
              </label>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Resumen:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.description }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Equipo:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.team }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Problema:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.problem }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Solución:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.solution }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Mercado y segmentos de clientes:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.market }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Propuesta de valor:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.value_proposal }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Canales y relación con clientes:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.channels_with_customers }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Modelo de ingresos:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.revenue_model }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Actividades y recursos claves:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.activities_resources }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Inversión y Estructura de costos:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.investment_cost }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Competencia y soluciones alternativas existentes:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.competence }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Impacto esperado:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.expected_impact }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2" v-if="data.curriculum_idea.length>0">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Antecedentes:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text" v-for="cv in data.curriculum_idea" :key="cv.id">
                <b>- {{ cv.type }}:</b><br>
                {{ cv.description }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </template>
    
  </v-row>
</template>
<script>

  export default {
    props: ['data'],
  }
</script>